import { useUserNameStore } from '@/store/userName.store';

/**
 * 根据 userId 展示用户名。
 * - 已知映射：展示 name
 * - 未知 / 未加载 / userId 缺失：展示 '-'，绝不回退展示原始 userId
 */
export function UserName({ userId }: { userId?: string | null }) {
  const name = useUserNameStore((s) => (userId ? s.nameMap[userId] : undefined));
  if (!userId) return <>-</>;
  return <>{name || '-'}</>;
}

export default UserName;
